module.exports = __webpack_public_path__ + "static/media/Named Buildings.ce448f1f.png";